import defaultClient from '@/plugins/axios/defaultClient'
import defaultV2Client from '@/plugins/axios/defaultV2Client'
import qs from 'query-string'

export default {
  getBankAccountHolderName({ bank, number }) {
    // v2 로 호출
    return defaultV2Client.get(`/bank-accounts/holder-name?${qs.stringify({ bank, number })}`)
    // return defaultClient.get(`/bank-accounts/find-holder-name?${qs.stringify({ bank, number })}`)
  },
  getBankCodes() {
    return defaultClient.get('/bank-accounts/bank-choices')
  },
  /**
   *
   * @param {*} param0
   * @returns
   */
  postBankAccounts({ bank, number }) {
    // v2 로 호출
    return defaultV2Client.post('/bank-accounts', { bank, number })
    // return defaultClient.post('/bank-accounts', { bank, number })
  },
}
